/*
* 项目回款管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Select,
    Button,
    Statistic,
    Input,
    DatePicker,
    Tag,
    Space,
    theme,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    winWidth,
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    ShowIPModal,
    isGTscreenWidth,
    rootReactDom,
    GetDropdownActionName,
    GetArrSpanMaxWidth,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import DetailRepaymentEntity from './DetailRepaymentEntity.js';
import RepaymentInfo from './RepaymentInfo';


const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[4].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[4].ptn;

const { RangePicker } = DatePicker;

const Lists = (props) => {
    const {
        token: {
            colorSuccess,
            colorSuccessBg,
        },
    } = theme.useToken();
    const update = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailRepaymentEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
                action={CNF.actionName.UPDATE}
            />);
    }

    /**
     * 打印项目回款
     * @param {*} record 
     */
    const showReapymentInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <RepaymentInfo
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
            />);
    }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'project/repayments/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.project_name, action, MODULENAME, props.isRefresh, uri);
                break
            default:
                break;
        }
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '项目名称', dataIndex: 'project_name', key: 'project_name', fixed: 'left', width: GetArrSpanMaxWidth(props.dataLists, 'project_name'), },
        {
            title: '回款金额(元)', key: 'amount', width: CNF.tableCreateTimeColumnWidth,
            render: (record) => <Button type='link' style={{ padding: 0, height: 22, width: '100%' }} onClick={() => {
                showReapymentInfo(record);
            }}><Tag style={{ width: '100%' }} color={colorSuccessBg}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={record.amount} /></Tag></Button>,
        },
        { title: '回款日期', dataIndex: 'date', key: 'date', width: CNF.tableCreateTimeColumnWidth, },
        { title: '付款方户名', dataIndex: 'payer_name', key: 'payer_name', width: GetArrSpanMaxWidth(props.dataLists, 'payer_name'), },
        {
            title: '付款方账户', key: 'payer_account', width: GetArrSpanMaxWidth(props.dataLists, 'payer_account'),
            render: (record) => record.payer_account ? record.payer_account : '-'
        },
        { title: '收款方户名', dataIndex: 'beneficiary_name', key: 'beneficiary_name', width: GetArrSpanMaxWidth(props.dataLists, 'beneficiary_name'), },
        {
            title: '收款方账户', key: 'beneficiary_account', width: GetArrSpanMaxWidth(props.dataLists, 'beneficiary_account'),
            render: (record) => record.beneficiary_account ? record.beneficiary_account : '-'
        },
        { title: '回款人员', dataIndex: 'personnel', key: 'personnel', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '备注', dataIndex: 'description', key: 'description', width: GetArrSpanMaxWidth(props.dataLists, 'description'),
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + 'delete') > 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>
                        总计: <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={props.sumAmount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={props.sumAmount >= 10000 ? props.sumAmount / 10000 : props.sumAmount} /></Tag>
                        共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条
                    </>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );

}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            projectUlid: '',
            projectLists: [],
            payerName: '',
            beneficiaryName: '',
            personnel: '',
            startDate: '',
            endDate: '',
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeProjectUlid = (value) => { this.setState({ projectUlid: value === undefined ? '' : value }); this.search(); }
    changePayerName = (e) => { this.setState({ payerName: e.target.value }); this.search(); }
    changeBeneficiaryName = (e) => { this.setState({ beneficiaryName: e.target.value }); this.search(); }
    changePersonnel = (e) => { this.setState({ personnel: e.target.value }); this.search(); }
    changeTimeInterval = (_, dateString) => { this.setState({ startDate: dateString[0], endDate: dateString[1] }); this.search(); };
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /***
    * 获取项目下拉列表
    */
    projectDDList = () => {
        const _this = this;
        const params = {
            'rss': 'list',
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}project/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    _this.setState({ projectLists: data.dat });
                }
            }
        })
    }

    /**
     * 获取列表
     */
    getLists = () => {
        const _this = this;
        const params = {
            'project_ulid': this.state.projectUlid,
            'payer_name': this.state.payerName,
            'beneficiary_name': this.state.beneficiaryName,
            'personnel': this.state.personnel,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}project/repayments${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt,
                            sumAmount: data.qss.amount,
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0,
                            sumAmount: 0,
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出为 Excel
    */
    exportAsExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目回款-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目回款明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目名称',
                    '回款金额(元)',
                    '回款日期',
                    '付款方户名',
                    '付款方账户',
                    '收款方户名',
                    '收款方账户',
                    '回款人员',
                    '备注'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
    */
    export() {
        const _this = this
        const params = {
            'project_ulid': this.state.projectUlid,
            'payer_name': this.state.payerName,
            'beneficiary_name': this.state.beneficiaryName,
            'personnel': this.state.personnel,
            'start_date': this.state.startDate,
            'end_date': this.state.endDate,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}project/repayments${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['project_number'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['image_uri'];
                            d.push(item);
                        }
                        _this.exportAsExecl(d);
                    } else {
                        _this.exportAsExecl([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.projectDDList();
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 5 : 6}>
                        <Select
                            showSearch
                            allowClear
                            placeholder='请选择项目'
                            style={{ width: '100%' }}
                            onChange={this.changeProjectUlid}
                            filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                        >
                            {
                                this.state.projectLists && this.state.projectLists.map((item) => {
                                    return <Option key={item.key} value={item.key}>{item.name}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            placeholder='付款方户名'
                            onChange={this.changePayerName}
                            value={this.state.payerName}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            placeholder='收款方户名'
                            onChange={this.changeBeneficiaryName}
                            value={this.state.beneficiaryName}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            placeholder='回款人'
                            onChange={this.changePersonnel}
                            value={this.state.personnel}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <RangePicker
                            format='YYYY-MM-DD'
                            placeholder={['开始日期', '结束日期']}
                            onChange={this.changeTimeInterval}
                            style={{ width: '100%' }}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            preGroup={this.props.preGroup}
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            sumAmount={this.state.sumAmount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT